<template>
  <div v-if="submitted === false" class="questions">
    <h1>COVID-19 Self Check</h1>
    <p><strong>Please complete this only if you are coming onto campus within the next 24 hours.</strong></p>
    <p>According to the CDC guidance on <a href="https://cdc.gov/coronavirus/2019-ncov/symptoms-testing/symptoms.html">Symptoms of Coronavirus</a>, people with COVID-19 have had a wide range of symptoms reported, ranging from mild symptoms to severe illness.</p>
    <!-- <ul>
      <li>Cough</li>
      <li>Shortness of breath or difficulty breathing</li>
      <li>Fever (over 100.4 degrees fahrenheit)</li>
      <li>Chills</li>
      <li>Muscle pain</li>
      <li>Sore throat</li>
      <li>New loss of taste or smell</li>
    </ul> -->
    <p class="question">Please indicate which campus you are arriving at</p>
    <div class="input-set">
      <select v-model="selected_campus">
        <option value="" selected>Select a Campus</option>
        <option v-for="campus in campuses" :key="campus._ID" :value="campus._ID">{{ campus.Description }}</option>
      </select>
    </div>
    <div v-for="symptom in symptoms" :key="symptom.name">
      <p class="question">{{ symptom.name }}</p>
      <p v-if="symptom.description !== null" v-html="symptom.description" />
      <div class="btn-set">
        <button @click="toggle(symptom, 'yes')" :class="symptom.yes === true ? 'yes' : ''">Yes</button>
        <button @click="toggle(symptom, 'no')" :class="symptom.no === true ? 'no' : ''">No</button>
      </div>

    </div>



      <div v-if="symptoms[2].yes === true">
        <div>
          <p class="question">{{ hcp_questions[0].name }}</p>
          <div class="btn-set">
              <button @click="toggle(hcp_questions[0], 'yes')" :class="hcp_questions[0].yes === true ? 'yes' : ''">Yes</button>
              <button @click="toggle(hcp_questions[0], 'no')" :class="hcp_questions[0].no === true ? 'no' : ''">No</button>
            </div>
        </div>

        <!-- <div v-if="hcp_questions[0].yes === true">
          <p class="question">{{ hcp_questions[1].name }}</p>
          <div class="btn-set">
              <button @click="toggle(hcp_questions[1], 'yes')" :class="hcp_questions[1].yes === true ? 'yes' : ''">Yes</button>
              <button @click="toggle(hcp_questions[1], 'no')" :class="hcp_questions[1].no === true ? 'no' : ''">No</button>
            </div>
        </div> -->

        
        <!-- <div v-for="hpc_question in hcp_questions" :key="hpc_question.name">
           <p class="question">{{ hpc_question.name }}</p>
            <p v-if="hpc_question.description !== null" v-html="hpc_question.description" />
            <div class="btn-set">
              <button @click="toggle(hpc_question, 'yes')" :class="hpc_question.yes === true ? 'yes' : ''">Yes</button>
              <button @click="toggle(hpc_question, 'no')" :class="hpc_question.no === true ? 'no' : ''">No</button>
            </div>
        </div> -->
      </div>
    <!-- <div>
      <p class="question">{{ travel_questions[0].name }}</p>
      <div class="btn-set">
        <button @click="toggle(travel_questions[0], 'yes')" :class="travel_questions[0].yes === true ? 'yes' : ''">Yes</button>
        <button @click="toggle(travel_questions[0], 'no')" :class="travel_questions[0].no === true ? 'no' : ''">No</button>
      </div>
    </div>

    <div v-if="travel_questions[0].yes === true">
      <p class="question">{{ travel_questions[1].name }}</p>
      <div class="btn-set">
        <button @click="toggle(travel_questions[1], 'yes')" :class="travel_questions[1].yes === true ? 'yes' : ''">Yes</button>
        <button @click="toggle(travel_questions[1], 'no')" :class="travel_questions[1].no === true ? 'no' : ''">No</button>
      </div>
    </div> -->
    <div>
      <div v-for="stipulation in stipulations" :key="stipulation.name">
        <p class="question">{{ stipulation.name }}</p>
        <p v-if="stipulation.description !== null" class="disclaimer"><em v-html="stipulation.description" /></p>
        <div class="btn-set">
          <button @click="toggle(stipulation, 'yes')" :class="stipulation.yes === true ? 'yes' : ''">I Agree</button>
          <button @click="toggle(stipulation, 'no')" :class="stipulation.no === true ? 'no' : ''">I Disagree</button>
        </div>
      </div>
    </div>
    <!-- <button v-if="symptom_free === false" class="submit-btn" @click="next()">Submit</button> -->
    <button class="submit-btn" @click="submit()">Submit</button>
  </div>
  <div v-else class="result">
    <div v-if="cleared === true" class="cleared">
      <div class="cleared-message">Cleared</div>
      <div v-if="monitor === true" class="cleared-instructions">keep monitoring symptoms, seek medical advice</div>
      <div class="cleared-name">{{ users_name }}</div>
      <div class="stamp">
      <div class="time">{{ last_checked.format('h:mm:ss a') }}</div>
      <div class="month">{{ last_checked.format('MMM') }}</div>
      <div class="day">{{ last_checked.format('DD')}}</div>
      <div class="year">{{ last_checked.format('YYYY') }}</div>
      </div>
    </div>
    <div v-else-if="disagree_to_mask === true" class="questions">
      <p class="question">Have you previously been granted an accomodation from Human Resources?</p>
      <div class="btn-set">
        <button @click="toggle(no_mask, 'yes')" :class="no_mask.yes === true ? 'yes' : ''">Yes</button>
        <button @click="toggle(no_mask, 'no')" :class="no_mask.no === true ? 'yes' : ''">No</button>
      </div>
      <button class="submit-btn" @click="submit_mask_exception()">Submit</button>
    </div>
    <div v-else-if="reset_answers === true">
     <h1>What made you submit incorrectly?</h1>
     <input type="text" v-model="reason" class="reason-text-field" style="width: 90%; height: 50px;">
     <button class="submit-btn" @click="reset_response()">Submit</button>
   </div>
    <div v-else class="not-cleared">
      <h1>COVID-19 Self Check</h1>
      <p>You are <strong>not cleared</strong> to enter campus.</p>
      <!-- <p style="padding:5px;">If this was submitted in error, or you need accomodations, please contact Michelle Glover Brown, Director for Environmental Health and Safety at <a href="tel:516.877.3242">516.877.3242</a>.</p> -->
      <div v-if="isolate === true">
        <p>Based on your response, You may return to campus upon completing at least 5 days of isolation from the onset of symptoms or 5 days of isolation after the first positive test if you remain asymptomatic.</p>
        <p>The Office of Health and Wellness will follow up with you to provide further guidance.</p>
        <button class="submit-btn" @click="present_reset_screen()">I submitted this in error</button>
      </div>
      <div v-if="quarantine === true">
        <p>Based on your response, you may return to campus upon completing at least 5 days of self-quarantine.</p>
        <p>The Office of Health and Wellness will follow up with you to provide further guidance.</p>
        <button class="submit-btn" @click="present_reset_screen()">I submitted this in error</button>
      </div>
      <div v-if="display_no_mask === true && disagree_to_mask === false">
        <p>Based on your response, you may return to campus after obtaining the required accomodations from <a href="mailto: Humanresources@adelphi.edu">Human Resources.</a></p>
        <p>Please contact Karen Loiacono at <a href="tel:516.877.3229">516.877.3229</a> or Joanna Ocampo at <a href="tel:516.877.3221">516.877.3221.</a></p>
        <button class="submit-btn" @click="present_reset_screen()">I submitted this in error</button>
        <!-- <button class="submit-btn" @click="request_accomodation()">Request Accomodation</button> -->
      </div>
      <p v-if="doctor_note === true">You may return to campus upon providing Health Services with note from your primary care physician clearing you.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'Questions',
  props: {
    msg: String
  },
  data: () => ({
    campuses: [],
    selected_campus: "",
    symptom_free: false,
    stipulation_state: false,
    result_state: false,
    cleared: false,
    monitor: false,
    isolate: false,
    quarantine: false,
    display_no_mask: false,
    doctor_note: false,
    disagree_to_mask: false,
    reset_answers: false,
    reason: '',
    no_mask: {
      'yes': false,
      'no': false,
    },

    submitted: false,
    last_checked_time: null,
    last_checked_date: null,
    last_checked: null,
    users_name: null,
     symptoms: [
      {
        'name': 'In the past 5 days, have you tested positive for COVID-19, or are awaiting test results?',
        'yes': false,
        'no': false
      },
      {
        'name': 'In the past 5 days, have you experienced any new onset of the following possible symptoms of COVID-19?',
        'yes': false,
        'no': false,
        'description': '<ul><li>Cough</li><li>Shortness of breath or difficulty breathing</li><li>Chills or Fever (over 100.4 degrees fahrenheit)</li><li>Muscle pain</li><li>Sore throat</li><li>Congestion or runny nose</li><li>Nausea or vomiting</li><li>Diarrhea</li><li>New loss of taste or smell</li><li>Headache</li><li>Fatigue</li></ul>'
      },
      {
        'name': 'In the past 5 days, have you knowingly been in close contact with anyone who has tested positive for COVID-19 or who has or had symptoms of COVID-19, and/or are awaiting test results?',
        'yes': false,
        'no': false
      }

    ],
    hcp_questions: [
      {
        'name': 'Have you completed a COVID-19 vaccination series and are at least 2 weeks out from your last dose?',
        'yes': false,
        'no': false
      }
    ],

    vaccine_questions: [
      {
        'name': 'Have you completed a COVID-19 vaccination series and are at least 2 weeks out from your last dose?',
        'yes': false,
        'no': false
      },
      {
        'name': 'Are you less than 90 days from a documented positive COVID diagnostic test and released from isolation by your local health department?',
        'yes': false,
        'no': false
      }
    ],

    // travel_questions: [
    //   {
    //     'name': 'Have you traveled to a non contiguous state in the past 10 days? (Contiguous states include: New Jersey, Connecticut, Pennsylvania, Massachusetts, and Vermont)',
    //     'yes': false,
    //     'no': false
    //   },
    //   {
    //     'name': 'Have you completed quarantine as per NYS travel advisory',
    //     'yes': false,
    //     'no': false
    //   }
    // ],


    stipulations: [
      {
        'name': 'Do you agree to abide by Adelphi’s COVID-19 mitigation policies?',
        'yes': false,
        'no': false,
        'description': 'These include:<ul><li>Practicing rigorous hand hygiene</li><li>Staying home if you become unwell</li><li>Wearing an appropriate face covering if and where it may be required.</li></ul>'
      },
    ]

  }),

  mounted() {
    axios.get('./remote-apis/status-api.php')
      .then(response => {
          const statuses = response.data.ROOT.Covid_SC_Statuses
         
          console.log(statuses)
          console.log(statuses.CovidSCDate)
          this.last_checked_date = statuses.CovidSCDate
          this.last_checked_time = statuses.CovidSCTime
          this.users_name = statuses.Name

          this.last_checked = moment(this.last_checked_date + ' ' + this.last_checked_time, 'MM/DD/YYYY hh:mm:ssa')

          console.log(this.last_checked)
          
          this.setDisplayLogic(statuses, false)
        
          
      })
      .catch(error => {
          window.console.error(error)
          this.submitted = false
          this.cleared = false
      })

      axios.get('./remote-apis/status-api.php?cmd=campuses')
        .then(response => {
          for (let i = 0; i < response.data.ROOT.Campuses.length; i++) {
            this.campuses.push(response.data.ROOT.Campuses[i]);
          }
          console.log(this.campuses[1].Description)
        })
        .catch(error => {
          console.error(error);
        })
  },

  watch: {
    cleared: function(val) {
      if (val === true) {
        document.getElementsByTagName('body')[0].classList.add('cleared-background')
      }
    }
  },

  methods: {

    toggle(question, answer) {
      if (answer === 'yes') {
        question.yes = true
        question.no = false
      }else if (answer === 'no') {
        question.yes = false
        question.no = true
      }
    },

    setDisplayLogic(statuses, no_masks_screen = true) {
      if (statuses.CovidSCStatus === 'GREEN') {
          
          this.submitted = true
          this.cleared = true

        }else {
          this.submitted = true
          this.cleared = false

          if (statuses.q1 === '1') {  // Tests positive
            this.isolate = true
          }else if (statuses.q2 === '0' && statuses.q3 === '1') { // No symptoms, but close contact with someone who tested positive
            if ((statuses.q1a === '1' && statuses.q1b === '0') && (statuses.agree_1 === '0' || statuses.agree_2 === '0')) {
              if (no_masks_screen === false) {
                this.disagree_to_mask = false
                this.display_no_mask = true
              }else {
                this.disagree_to_mask = true
                this.display_no_mask = false
              }
            }else {
              this.quarantine = true
            }
          }else if (statuses.q2 === '1' && statuses.q3 === '1') { // Has symptoms, and close contact
            this.isolate = true
          }else if (statuses.q2 === '1') { // Has symptoms, no test, and no contact
            this.isolate = true
          }else if ((statuses.q1 === '0' && statuses.q2 === '0' && statuses.q3 === '0') && statuses.agree_1 === '0' || statuses.agree_2 === '0') {
            if (no_masks_screen === false) {
              this.disagree_to_mask = false
              this.display_no_mask = true
            }else {
              this.disagree_to_mask = true
              this.display_no_mask = false
            }
          }else if ((statuses.restricted_state === '1' && statuses.quarantined === '0')) {
            this.quarantine = true
          }


          
        }
    },
    
    submit() {

      const self = this

      const not_checked = !this.symptoms.some((element) => element.no === false && element.yes === false)
      const symptoms_checked = !this.symptoms.every((element) => element.no === true)
      const agreed_checked = this.stipulations.every((element) => element.yes === true)
      const agreed_null = this.stipulations.some((element) => element.yes === false && element.no === false) // Neither yes nor no are checked
      // const agreed_no = this.stipulations.some((element) => element.no === true)
      let formData = new FormData();
      formData.append('ag1u', 0)
      formData.append('campus', this.selected_campus)
      if (not_checked === false || this.selected_campus === "") {
        alert('All questions must be answered.')
      }else {
       
        if (agreed_null === false) {
          

          for (let i = 0; i < this.symptoms.length; i++) {
            console.log(this.symptoms[i].yes)
            formData.append('q'+i, (this.symptoms[i].yes === true ? 1 : 0))
          }

          for (let i = 0; i < this.stipulations.length; i++) {

            formData.append('agree'+i, (this.stipulations[i].yes === true ? 1 : 0))
          }

          formData.append('q1a', (this.hcp_questions[0].yes === true ? 1 : 0))
          // formData.append('q1b', (this.hcp_questions[1].yes === true ? 1 : 0))

          // formData.append('restricted_state', (this.travel_questions[0].yes === true ? 1 : 0))
          // formData.append('quarantined', (this.travel_questions[1].yes === true ? 1 : 0))
          
          if (this.symptoms[0].yes === false && this.symptoms[1].yes === true && this.symptoms[2].yes === false) {
            formData.append('status', 'RED')
              
          }else if ((this.symptoms[0].yes === false && this.symptoms[1].yes === false && this.symptoms[2].yes === false) && (this.stipulations[0].yes === false)) {
            formData.append('status', 'RED');
          }else if (symptoms_checked === false) { // All questions answered "right"
            // if (this.travel_questions[0].yes === true && this.travel_questions[1].yes === false) {
              
            //   formData.append('status', 'RED')
            // }else {
              formData.append('status', 'GREEN')
            // }
          }else if (agreed_checked === false) {
            formData.append('status', 'RED')
            
          }else {
            if (this.hcp_questions[0].yes === true) {
              
              formData.append('q1a', 1)
              // formData.append('q1b', 0)
              formData.append('status', 'GREEN')
            }else {
              formData.append('q1a', 0)
              // formData.append('q1b', 1)
              formData.append('status', 'RED')
            }
          }

          
          
          axios.post('./remote-apis/status-api.php', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(response => {
              console.log(response)
              axios.get('./remote-apis/status-api.php')
                .then(response => {

                  console.log(response)
                  const statuses = response.data.ROOT.Covid_SC_Statuses
        
                  console.log(statuses)
                  console.log(statuses.CovidSCDate)
                  self.last_checked_date = statuses.CovidSCDate
                  self.last_checked_time = statuses.CovidSCTime
                  self.users_name = statuses.Name

                  // for (let i = 0; i < this.symptoms.length; i++) {
                  //   console.log('Symptom '+i+': '+this.symptoms[i].yes)
                  // }

                  // for (let i = 0; i < this.stipulations.length; i++) {
                  //   console.log('Agreed: '+this.stipulations[i].yes)
                  // }
                  

                  self.last_checked = moment(this.last_checked_date + ' ' + this.last_checked_time, 'MM/DD/YYYY hh:mm:ssa')

                  console.log(this.last_checked)
                  
                  self.setDisplayLogic(statuses)

                  
                  self.submitted = true
                })
              
            })
          
        }else {
          alert('All questions must be answered.')
        }
      
        
      }

    },

    submit_mask_exception() {
      if (this.no_mask.yes === true) {
        const self = this
        let formData = new FormData()
        formData.append('ag1u', 1)
        formData.append('status', 'GREEN')
        formData.append('agree0', 1)
        
        axios.post('./remote-apis/status-api.php', formData)
          .then(response => {
            console.log(response)
            axios.get('./remote-apis/status-api.php')
                .then(response => {

                  const statuses = response.data.ROOT.Covid_SC_Statuses
         
                  self.last_checked_date = statuses.CovidSCDate
                  self.last_checked_time = statuses.CovidSCTime
                  

                  self.last_checked = moment(this.last_checked_date + ' ' + this.last_checked_time, 'MM/DD/YYYY hh:mm:ssa')

                  console.log(statuses.agree_1)
                  
                  self.setDisplayLogic(statuses)

                })
          })
        
      }else {
        //console.log(response)
        const self = this
        // let formData = new FormData()
        // formData.append('ag1u', 0)
        // formData.append('status', 'RED')
        // formData.append('agree0', 0)

        axios.get('./remote-apis/status-api.php')
            .then(response => {

              const statuses = response.data.ROOT.Covid_SC_Statuses
      
              self.last_checked_date = statuses.CovidSCDate
              self.last_checked_time = statuses.CovidSCTime
              self.users_name = statuses.Name

              self.last_checked = moment(this.last_checked_date + ' ' + this.last_checked_time, 'MM/DD/YYYY hh:mm:ssa')

              console.log(statuses.agree_1)
              self.setDisplayLogic(statuses, false)

            })
      }
    },

    request_accomodation() {
      axios.post('./remote-apis/status-api.php?cmd=contact-hr')
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.error(error)
        })
    },

    present_reset_screen() {
      this.reset_answers = true
    },

    reset_response() {
        const self = this
        let formData = new FormData()
        
        formData.append('reason', this.reason)

        axios.post('./remote-apis/status-api.php?cmd=submit-reset-reason', formData)
          .then(response => {
            console.log(response)
            self.cleared = false
            self.submitted = false
            self.reset_answers = false
            // axios.get('./remote-apis/status-api.php?cmd=clear')
            // .then(response => {
            //   console.log(response)
            //   self.cleared = false
            //   self.submitted = false
            //   self.reset_answers = false
            // })
        })
     
        
      }
  },

     
}
</script>


